import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import App from '@/App.vue'

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [{ path: '/', name: 'App', component: App }],
})

createApp(App).use(router).mount('#app')
